import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import CandidatePage from '../../pages/CandidatePage';
import NotFoundPage from './NotFoundPage';
import InvalidTokenPage from './InvalidTokenPage';

const InterviewRouteWrapper: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [loading, setLoading] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [tokenInvalid, setTokenInvalid] = useState(false);
  const [candidateToken, setCandidateToken] = useState<string | null>(token);

  useEffect(() => {
    const validateRoute = async () => {
      setLoading(true);
      setTokenInvalid(false);

      // トークンベースのアクセス（新形式）
      if (token) {
        // トークンは有効性チェックをCandidatePageで行う
        // ここではトークンを保持するだけ
        setCandidateToken(token);
        setIsValid(true);
        setLoading(false);
        return;
      }

      // トークンも旧形式パラメータもない場合
      setIsValid(false);
      setTokenInvalid(true);
      setLoading(false);
    };

    validateRoute();
  }, [token]);

  // ローディング中
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="relative">
            <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto"></div>
          </div>
          <div className="mt-4">
            <h3 className="text-lg font-medium text-gray-900 mb-2">AI面接を準備中...</h3>
            <p className="text-sm text-gray-500">企業情報と面接設定を確認しています</p>
          </div>
        </div>
      </div>
    );
  }

  // トークンが無効な場合
  if (tokenInvalid) {
    return <InvalidTokenPage />;
  }

  // 無効なパラメータの場合は404ページを表示
  if (!isValid) {
    return <NotFoundPage type="interview" />;
  }

  // 有効な場合は面接ページを表示
  // トークンベースの場合は、CandidatePageにトークンを渡す
  return (
    <CandidatePage
      candidateToken={candidateToken || undefined}
    />
  );
};

export default InterviewRouteWrapper;
